export interface Event {
  date: string;
  startTime: number | null;
  endTime: number | null;
  description: string | null;
  impact: string | null;
}

export interface SlsData {
  sls: number;
  availabilityLastMonth: number;
  availabilityLast12Months: number;
  events: Event[];
  lastMonthThroughputIn: number;
  lastMonthThroughputOut: number;
  last12MonthsThroughputIn: number;
  last12MonthsThroughputOut: number;
  startDateSubscription: string;
}

export const EMPTY_SLS_DATA = {
  sls: 0,
  availabilityLastMonth: 0,
  availabilityLast12Months: 0,
  events: [],
  lastMonthThroughputIn: 0,
  lastMonthThroughputOut: 0,
  last12MonthsThroughputIn: 0,
  last12MonthsThroughputOut: 0,
  startDateSubscription: new Date(new Date().getFullYear() - 1, new Date().getMonth(), 1).toISOString(),
};
